export enum TicketStatus {
  OPEN = 'Open',
  IN_PROGRESS = 'InProgress',
  CLOSED = 'Closed',
  REOPENED = 'Reopened',
}

export enum TicketCategory {
  CUSTOMERS = 'Customers',
  CALL = 'Call',
  SYNCHRONIZATION = 'Synchronization',
  NFA = 'NFA',
  REPORTS = 'Reports',
  EXPENSES = 'Expenses',
  INVOICES = 'Invoices',
  DOUBLE_VISITS = 'Double visits',
  LEAVE_BALANCE = 'Leave balance',
  OTHERS = 'Others',
}

export enum TicketPriority {
  LOW = 'Low',
  MEDIUM = 'Medium',
  HIGH = 'High',
  URGENT = 'Urgent',
}

export enum TicketSenderRole {
  USER = 'User',
  ADMIN = 'Admin',
}

export interface Ticket {
  id: string;
  ticketNumber: string;
  userId: string;
  companyId: string;
  title: string;
  description?: string;
  status: TicketStatus;
  category: TicketCategory;
  priority: TicketPriority;
  isDeleted: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface TicketMessage {
  id: string;
  ticketId: string;
  userId?: string | TicketMessageUser;
  adminId?: string;
  senderRole: TicketSenderRole;
  text?: string;
  audioUrl?: string;
  videoUrl?: string;
  attachments?: string[];
  isRead: boolean;
  isDeleted: boolean;
  createdAt: string;
}

export interface TicketMessageUser {
  id: string;
  name: string;
}

export interface TicketDetails {
  ticket: Ticket;
  messages: TicketMessage[];
}

export interface TicketFiles {
  attachments?: File[];
  audio?: File | null;
  video?: File | null;
}

export interface TicketReplyPayload extends TicketFiles {
  text?: string;
}

export interface CreateTicketPayload extends TicketFiles {
  title: string;
  description?: string;
  category: TicketCategory;
  priority: TicketPriority;
}

export interface CreateTicketResponse {
  ticket: Ticket;
  message: TicketMessage;
}

export const MAX_TICKET_FILE_SIZE = 10 * 1024 * 1024;
export const MAX_TICKET_ATTACHMENTS = 5;
export const MAX_TICKET_MESSAGE_LENGTH = 2000;
export const TICKET_MESSAGE_PREVIEW_LENGTH = 500;
export const TICKET_ATTACHMENT_ACCEPT =
  'image/png,image/jpeg,image/jpg,image/gif,application/pdf,text/csv,application/csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,.csv,.xlsx';
export const TICKET_AUDIO_ACCEPT =
  'audio/mpeg,audio/wav,audio/ogg,audio/webm,audio/mp4,audio/x-m4a';
export const TICKET_VIDEO_ACCEPT = 'video/mp4,video/webm,video/ogg';
